import {
  Flex,
  IconInfoSolid,
  Text,
  TextArea,
  TextInput,
  Tooltip,
} from "@instructure/ui";
import { useTranslation } from "react-i18next";
import { useEffect } from "react";

const EmbeddedDashboard = ({
  dashNameRef,
  dashName,
  dashboardUrl,
  setDashboardUrl,
  dashboardDesc,
  setDashboardDesc,
  inTemplate,
}) => {
  const { t } = useTranslation();

  useEffect(() => {
    if (dashNameRef.current) {
      dashNameRef.current.value = dashName;
    }
  }, [dashName, dashNameRef]);

  return (
    <Flex wrap="wrap" gap="small">
      <Flex.Item size="75%">
        <TextInput
          renderLabel={<Text size="small">{t("assessment.name")}</Text>}
          size="small"
          inputRef={(el) => (dashNameRef.current = el)}
          interaction={inTemplate ? "disabled" : "enabled"}
        />
      </Flex.Item>
      <Flex.Item size="100%">
        <TextArea
          label={<Text size="small">{t("embeddedDashboard.description")}</Text>}
          defaultValue={dashboardDesc}
          onBlur={(e) => setDashboardDesc(e.target.value)}
          disabled={inTemplate}
        />
      </Flex.Item>
      <Flex.Item size="75%">
        <TextInput
          renderLabel={
            <Text size="small">
              {t("embeddedDashboard.dashURL")}{" "}
              <Text size="small" color="secondary" fontStyle="italic">
                ({t("form.optional")}){" "}
              </Text>
              <Tooltip renderTip={t("embeddedDashboard.info")} placement="end">
                <IconInfoSolid color="brand" />
              </Tooltip>
            </Text>
          }
          size="small"
          defaultValue={dashboardUrl}
          onBlur={(e) => setDashboardUrl(e.target.value)}
        />
      </Flex.Item>
    </Flex>
  );
};

export default EmbeddedDashboard;
